import { useSyncUsers } from "features/Integrations/hooks";
import { TertiaryButton } from "components/Button";

interface SyncUsersButtonProps {
  onSuccess?: () => void;
}

export default function SyncUsersButton({ onSuccess = () => {} }: SyncUsersButtonProps) {
  const {
    performRequest: syncChannels,
    state: { loading: isLoading },
  } = useSyncUsers({ onSuccess });
  return (
    <TertiaryButton
      onClick={() => syncChannels()}
      isLoading={isLoading}
      loadingText="Syncing Users"
      size="sm"
      height="100%"
      px={6}
      py={1}
    >
      Sync Users
    </TertiaryButton>
  );
}
